import { render, staticRenderFns } from "./proxySettingsForm.vue?vue&type=template&id=6c74a9bc&"
import script from "./proxySettingsForm.vue?vue&type=script&lang=ts&"
export * from "./proxySettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports